"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.addClass = exports.getDisplayName = exports.filterProps = void 0;
var element_1 = require("./element");
__createBinding(exports, element_1, "filterProps");
__createBinding(exports, element_1, "getDisplayName");
__createBinding(exports, element_1, "addClass");
//# sourceMappingURL=index.js.map